import PlanningContent from './PlanningContent/PlanningContent.jsx';

const Planning = () => {
  return <PlanningContent />;
};

export default Planning;
